import { render, staticRenderFns } from "./BTN.vue?vue&type=template&id=7ce33fdd&lang=pug"
import script from "./BTN.vue?vue&type=script&lang=js"
export * from "./BTN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports